module.exports = __webpack_public_path__ + "img/receive parcel.2b6326a4.svg";